<template>
  <div class="Category mb-5 w-100 row">
    <div
      ref="categoryItem"
      class="Category__item p-2"
      @click="handleChangeCategory(idx)"
      v-for="(category, idx) in categories"
      :key="idx"
    >
      <div class="Category__img" :class="{active: tab == idx}">
        <img :src="img(category.image)" alt />
      </div>
      <div class="Category__title">{{category.name.toLocaleUpperCase('TR')}}</div>
    </div>

    <div
      class="Category__active"
      :class="{Category__radiusLeft: tab == 0, Category__radiusRight: tab == 4 }"
      :style="{left: activeLeft + 'px', width:  tabWidth}"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    categories: {
      type: Array
    }
  },
  data() {
    return {
      tab: 0,
      activeLeft: 0,
      tabWidth: 0
    }
  },
  mounted() {
    const categoryName = this.$route.hash.replace('#', '')

    this.categories.forEach((item, idx) => {
      if (this.turkishToEnglish(item.name) === categoryName) {
        this.changeCategory(idx)
      }
    })
    this.tabWidth = `${this.$refs.categoryItem[0].offsetWidth}px`
    if (this.tab === 0) {
      this.activeLeft = 15
    }
  },
  methods: {
    turkishToEnglish(str) {
      return str
        .replace('Ğ', 'g')
        .replace('Ü', 'u')
        .replace('Ş', 's')
        .replace('I', 'i')
        .replace('İ', 'i')
        .replace('Ö', 'o')
        .replace('Ç', 'c')
        .replace('ğ', 'g')
        .replace('ü', 'u')
        .replace('ş', 's')
        .replace('ı', 'i')
        .replace('ö', 'o')
        .replace('ç', 'c')
        .replace(' ', '-')
        .toLowerCase()
    },
    handleChangeCategory(idx) {
      const name = this.turkishToEnglish(this.categories[idx].name)
      window.history.replaceState(null, null, `#${name}`)
      this.changeCategory(idx)
    },
    changeCategory(idx) {
      this.tab = idx
      this.activeLeft = idx * this.$refs.categoryItem[0].offsetWidth + 15
      this.$emit('tabChanged', idx)
    }
  },
  created() {
  },
  destroyed() {
    // this.$root.$off("category_loaded");
  }
}
</script>
